import React from 'react';
import { profileData } from '../data/siteContent';

const Footer = () => {
  return (
    <footer className="relative bg-black border-t-2 border-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white font-black text-xl">
            {profileData.name}
          </p>
          <p className="text-gray-400 text-sm">
            © 2026 OKNEFF. All rights reserved.
          </p>
          <img 
            src="/okneff-logo.png" 
            alt="OKNEFF" 
            className="h-16 object-contain"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;